import { gql } from '@apollo/client'
import { IShopifyProductSelectedOptionInput } from '../../domains/shopify/ShopifyProduct'
import IShopifyVariantBySelectedOptionsResponse from '../../domains/shopify/ShopifyVariantBySelectedOptionsResponse'

// TODO: Fix this, removing if not really needed
const query = gql`
  query ShopifyVariant($selectedOptions: [SelectedOptionInput!]!, $handle: String!) {
    product: productByHandle(handle: $handle) {
      id
      variantBySelectedOptions(selectedOptions: $selectedOptions) {
        id
        title
        availableForSale
        quantityAvailable
        sku
      }
    }
  }
`

/**
 * https://help.shopify.com/en/api/storefront-api/reference/queryroot
 *
 * @param {{handle: string}} variables
 */
const queryVariantBySelectedOptions = async (
  client: any,
  variables: {
    selectedOptions: IShopifyProductSelectedOptionInput[]
    id: string
    handle: string
  },
): Promise<IShopifyVariantBySelectedOptionsResponse> => await client.query({ query, variables })

export default queryVariantBySelectedOptions
